export default "__VITE_ASSET__Dy0qUFec__"